import React, { useState, useEffect } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Box, Tabs, Tab } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';

// Icons
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import BusinessIcon from '@mui/icons-material/Business';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PaymentIcon from '@mui/icons-material/Payment';
import CampaignIcon from '@mui/icons-material/Campaign';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AppsIcon from '@mui/icons-material/Apps';
import BadgeIcon from '@mui/icons-material/Badge';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PublicIcon from '@mui/icons-material/Public';

// Components
import ARCCustomer from '../../Containers/ARC_Upload/sales/BussinessCustomerMang/BussinessCustomerMang';
import ARCInvoiceManagement from '../../Containers/ARC_Upload/sales/InvoiceManagement/InvoiceManagement';
import ARCCollections from '../../Containers/ARC_Upload/sales/Collections/Collections';
import ARCPaymentAdvice from '../../Containers/ARC_Upload/sales/PaymentAdvice/PaymentAdvice';
import VenderManagement from '../../Containers/ARC_Upload/Purchase/VendorManagement/VenderManagement';
import PurchaseInvoiceMgmt from '../../Containers/ARC_Upload/Purchase/BillManagement/PurchaseMgmt';
import VendorCollections from '../../Containers/ARC_Upload/Purchase/Collections/Collections';
import VendorpaymentAdvice from '../../Containers/ARC_Upload/Purchase/VendorPaymentsAdvice/VendorpaymentAdvice';
import COAManagement from './COA/coa';
import DaybookManagement from './Daybook/daybook';
import EmployeeDetails from './EmployeeDetails/Employeedetails';
import TDSTransactionDetails from './TDSTransactionDetails/TDSTransactiondetails';
import DataUploadCards from './DataUploadsCards';
import NRIDetails from './NRIDetails/NRIDetails';

// Styles
const toggleButtonStyle = {
    flex: 1,
    border: 0,
    borderRadius: '30px',
    textTransform: 'none',
    px: 3,
    py: 1,
    fontWeight: 600,
    color: '#000000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    '&.Mui-selected': {
        backgroundColor: 'var(--main-btn-color)',
        color: '#ffffff',
    },
    '&:hover': { backgroundColor: 'transparent' },
    '&.Mui-selected:hover': { backgroundColor: 'var(--main-btn-color)' },
};

export default function ArcDataUploads() {
    const history = useHistory();
    const location = useLocation();

    const arcUploadSale = localStorage.getItem("arcUploadSale") === "true";
    const arcUploadPurchase = localStorage.getItem("arcUploadPurchase") === "true";
    const daybook = localStorage.getItem("daybook") === "true";
    const coa = localStorage.getItem("coa") === "true";
    const employeeDetails = localStorage.getItem("employee_details") === "true";
    const tdsTransactionDetails = localStorage.getItem("tds_transaction_details") === "true";
    const nriDetails = localStorage.getItem("nri_details") === "true";

    const salesTabs = arcUploadSale ? [
        { label: 'Customer', icon: <PeopleAltIcon />, path: '/BusinessCustomerManagement', component: ARCCustomer },
        { label: 'Invoice Management', icon: <ReceiptLongIcon />, path: '/InvoiceManagement', component: ARCInvoiceManagement },
        { label: 'Collections', icon: <CurrencyRupeeIcon />, path: '/uploadCollectionsData', component: ARCCollections },
        { label: 'Payment Advice', icon: <NotificationsActiveIcon />, path: '/uploadPaymentAdviceData', component: ARCPaymentAdvice },
    ] : [];

    const purchaseTabs = arcUploadPurchase ? [
        { label: 'Vendor', icon: <BusinessIcon />, path: '/vendorManagement', component: VenderManagement },
        { label: 'Bill Management', icon: <ReceiptIcon />, path: '/PurchaseInvoiceMgmt', component: PurchaseInvoiceMgmt },
        { label: 'Vendor Payment', icon: <PaymentIcon />, path: '/vendorCollections', component: VendorCollections },
        { label: 'Payment Advice', icon: <CampaignIcon />, path: '/VendorpaymentAdvice', component: VendorpaymentAdvice },
    ] : [];

    const othersTabs = [
        ...(daybook ? [{ label: 'Day Book', icon: <ReceiptIcon />, path: '/daybook', component: DaybookManagement }] : []),
        ...(coa ? [{ label: 'Chart of Accounts', icon: <AccountBalanceIcon />, path: '/coa', component: COAManagement }] : []),
        ...(employeeDetails ? [{ label: 'Employee Details', icon: <BadgeIcon />, path: '/employeeDetails', component: EmployeeDetails }] : []),
        ...(tdsTransactionDetails ? [{ label: 'TDS Transaction Details', icon: <AccountBalanceWalletIcon />, path: '/tdsTransactionDetails', component: TDSTransactionDetails }] : []),
        ...(nriDetails ? [{ label: 'NRI Details', icon: <PublicIcon />, path: '/nriDetails', component: NRIDetails }] : []),
    ];

    const allTabs = [...salesTabs, ...purchaseTabs, ...othersTabs];
    const allPaths = allTabs.map(tab => tab.path);

    const MAIN_UPLOAD_PATH = '/Data-Upload';// 

    const isOnMainPage = location.pathname === MAIN_UPLOAD_PATH;
    const isOnSpecificTab = allPaths.includes(location.pathname);

    if (isOnMainPage || !isOnSpecificTab) {
        return <DataUploadCards />;
        }

    const activeTab = allTabs.find(tab => tab.path === location.pathname);
    const ActiveComponent = activeTab?.component;

    return (
        <Box sx={{ fontFamily: "'Inter', sans-serif", width: '100%' }}>
            {ActiveComponent ? <ActiveComponent /> : null}
        </Box>
    );
}